<template>
    <div class="w-full -mt-2">
        <input-radio-boolean
            :name="'tenant[' + tenant.id + '][has_deferred_rent]'"
            v-model="tenant.has_deferred_rent"
            true="Yes"
            false="No"
            class="pt-2"
            :read_only="read_only"
        />

        <input-text
            v-if="tenant.has_deferred_rent"
            class="w-full pt-3"
            :name="'tenant[' + tenant.id + '][deferred_rent_notes]'"
            :value="tenant.deferred_rent_notes"
            :read_only="read_only"
        />
    </div>
</template>

<script>
export default {
    props: {
        read_only: { default: false },
        tenant: {},
    },
}
</script>
